import _ from 'lodash';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  application: {},
  property: {},
  initialApplicationData: {},
  breakdown: {},
  documents: [],
  error,
  finalSucessData: null,
  companyLookup: [],
  emrtsLookup: [],
};

export default function applicationReducerMusataha(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_APPLICATION_MUSATAHA:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_APPLICATION_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        application: _.get(action.payload, 'application'),
        initialApplicationData: _.get(action.payload, 'initialApplicationData'),
        documents: _.get(action.payload, 'documents'),
        property: _.get(action.payload, 'property'),
        breakdown: _.get(action.payload, 'application.paymentBreakDown'),
        companyLookup: action.payload.companyLookup,
        emrtsLookup: action.payload.emrtsLookup,
        error: null,
      };
    case types.FETCH_APPLICATION_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: _.get(action.payload, 'error'),
      };
    case types.MUSATAHA_APPROVE:
      return {
        ...state,
        loading: true,
      };
    case types.MUSATAHA_APPROVE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.MUSATAHA_APPROVE_ERROR:
      return {
        ...state,
        loading: false,
        properties: null,
        error: action.payload,
      };
    case types.MUSATAHA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        properties: null,
        error: action.payload,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA:
      return {
        ...state,
        loading: true,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
